import { Color, Modal, useSnackbarsPipeline } from "@bonliva-crm/ui";
import { ContractUnion } from "../types";
import { FormLabel, MenuItem, Select, makeStyles } from "@material-ui/core";
import locale, { dateFormat } from "@bonliva-crm/locale";
import {
  ConsultantContractTableRowDataFragment,
  ContractType,
  GetConsultantContracts,
  LegalPersonType,
  useAddSalaryChoiceToConsultantContractMutation
} from "@bonliva-crm/graphql";
import { useEffect, useState } from "react";
import { getConsultantAgeGroup } from "@bonliva-crm/shared";
import moment from "moment";
import { useTenant } from "@hooks";

type Props = {
  consultantId: string;
  contract: ContractUnion;
  showNationalProcurement?: boolean;
  customerContract?: boolean;
  open: boolean;
  setOpen: (o: boolean) => void;
};

export const AddSalaryChoiceModal = (props: Props) => {
  const classes = useStyles();
  const [isAbove60, setIsAbove60] = useState(false);
  const { tenant } = useTenant();
  const [contractType, setContractType] = useState<ContractType>();
  const [addSalaryChoiceToConsultantContractMutation] =
    useAddSalaryChoiceToConsultantContractMutation();

  const consultantPension = () => {
    const contract = { ...props.contract } as ConsultantContractTableRowDataFragment;
    // if consultant is subcontractor, we don't need to show pension options
    if (contract?.Consultant?.LegalPersonType === LegalPersonType.Subcontractor) {
      return null;
    }

    if (!contract?.Consultant?.BirthDate || !contract?.StartDate || !contract?.EndDate) {
      return null;
    }

    return getConsultantAgeGroup(
      moment(contract?.Consultant.BirthDate).format(dateFormat),
      moment(contract.StartDate).format(dateFormat),
      moment(contract.EndDate).format(dateFormat)
    );
  };

  useEffect(() => {
    if (props.open) {
      const { above60 } = consultantPension();
      setIsAbove60(above60);
    }
  }, [props.open]);

  const { showSuccess, showError } = useSnackbarsPipeline();
  let _opt = Object.keys(locale.contractType);
  if (!props.showNationalProcurement) {
    _opt = _opt.filter((c) => c !== ContractType.NationalProcurement);
  }
  if (tenant === "wcc" && isAbove60) {
    _opt = _opt.filter((c) => c !== ContractType.HourlyPensionInsurance);
  }

  return (
    <Modal
      open={props.open}
      setOpen={props.setOpen}
      onClose={() => props.setOpen(false)}
      modalContent={
        <>
          <FormLabel required id="label" className={classes.bodyColor}>
            {locale.SalaryChoice}
          </FormLabel>
          <Select
            color="secondary"
            value={contractType}
            onChange={(e) => setContractType(e.target.value as ContractType)}
          >
            {_opt.map((key) => (
              <MenuItem value={key}>{locale.contractType[key]}</MenuItem>
            ))}
          </Select>
        </>
      }
      onSubmit={() => {
        addSalaryChoiceToConsultantContractMutation({
          variables: {
            contractId: props.contract._id,
            salaryChoice: contractType
          },
          onCompleted: () => {
            showSuccess(locale.Saved);
            props.setOpen(false);
          },
          onError: (e) => {
            showError(locale.ErrorOccurred);
            console.error(e);
          },
          refetchQueries: [GetConsultantContracts.OperationName]
        });
      }}
    />
  );
};

const useStyles = makeStyles(() => ({
  bodyColor: {
    color: Color.Body
  }
}));
